module.exports = __webpack_public_path__ + "img/clock-black.png";